import React from "react";
import { motion } from "framer-motion";

const PILLARS = [
  {
    title: "Astrology",
    italic: "the soul map",
    body:
      "Tropical Western chart with the precision of Swiss Ephemeris and the nuance of Placidus houses. We read your Sun, Moon, Ascendant, planets, houses and major aspects so you understand the archetypes you incarnated to embody.",
  },
  {
    title: "Human Design",
    italic: "the energy mechanics",
    body:
      "Born from the I-Ching, Astrology, the Kabbalah and the chakra system. We map your BodyGraph to reveal your Type, Strategy, Authority, Profile and defined centers — the operating system you should run, not fight.",
  },
  {
    title: "Gene Keys",
    italic: "the contemplative path",
    body:
      "A living transmission by Richard Rudd. Every gate has three frequencies — Shadow, Gift and Siddhi. We highlight your four prime gifts so you know exactly which patterns to soften and which gifts to express.",
  },
];

export default function WisdomSection() {
  return (
    <section
      id="wisdom"
      data-testid="wisdom-section"
      className="relative py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="text-center max-w-3xl mx-auto mb-20"
        >
          <p className="font-sans text-xs tracking-overline text-[#D4AF37] mb-4">03 — the wisdom we weave</p>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-white tracking-tight">
            Three sciences. <span className="italic gold-text">One self.</span>
          </h2>
          <p className="mt-6 font-sans text-base sm:text-lg text-slate-300 leading-relaxed">
            We don't pick favourites. The most accurate self-portrait emerges when these three lenses look at you at once.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="glass-card rounded-3xl p-8"
              data-testid={`pillar-${p.title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <p className="font-sans text-[10px] uppercase tracking-overline text-[#D4AF37] mb-4">
                {String(i + 1).padStart(2, "0")}
              </p>
              <h3 className="font-serif text-3xl text-white">{p.title}</h3>
              <p className="font-serif italic text-lg text-[#D4AF37]/90 mt-1">{p.italic}</p>
              <p className="mt-6 font-sans text-sm text-slate-300 leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
